import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ForumsService } from 'src/app/services/forums.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss'
})
export class IndexComponent {

  public forumsLoaded: boolean = false;
  public forums: any = [];
  public fixed_forums: any = [];
  public lang = this.languageService.getLanguage();
  constructor(
    private forumsService: ForumsService,
    private languageService: LanguageService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.getResources();
  }

  getResources() {
    this.forumsService.getResources().subscribe({
      next: response => {
        this.forums = response.forums;
        this.fixed_forums = response.fixed;
        this.forumsLoaded = true;
      },
      complete: () => {},
      error: error => {
        this.forumsLoaded = true;
        console.log("GetResourceError: ", error);
      }
    });
  }

  toggleLike(index: number, fixed: boolean = false) {
    let forum = fixed ? this.fixed_forums[index] : this.forums[index];
    if (forum.liked_by_current_user) {
      if (!forum.forum_unlike_path) {
        return;
      }
      forum.liked_by_current_user = false;
      forum.likes_count -= 1;
      this.forumsService.dislikeResource(forum.forum_unlike_path).subscribe({
        next: response => {
        },
        complete: () => {},
        error: error => {
          forum.liked_by_current_user = true;
          forum.likes_count += 1;
          this.toastr.error('Error al quitar like al recurso');
          console.log("UnlikeResourceError: ", error);
        }
      });
    }  else {
      forum.liked_by_current_user = true;
      forum.likes_count += 1;
      this.forumsService.likeResource(forum.forum_like_path).subscribe({
        next: response => {
          forum.forum_unlike_path = response.forum_unlike_path;
        },
        complete: () => {},
        error: error => {
          this.toastr.error('Error al dar like al recurso');
          console.log("LikeResourceError: ", error);
        }
      });
    }
  }
}
